module.exports = __webpack_public_path__ + "img/potato-with-blue-eyes.3a9db34e.png";